export default function PaperClip() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1603_169619)">
        <path
          d="M1.24495 16.2449C-0.414984 14.5849 -0.414984 11.8936 1.24495 10.2337L9.51033 1.96832C11.4525 0.0261846 14.6013 0.0261846 16.5434 1.96832C18.4855 3.91046 18.4855 7.05926 16.5434 9.0014L8.50184 17.043C8.21545 17.3294 7.73786 17.3382 7.45689 17.0465C7.18439 16.7637 7.18762 16.3134 7.46655 16.0344L15.5215 7.97948C16.8993 6.60174 16.8993 4.36795 15.5215 2.99021C14.1438 1.61247 11.91 1.61247 10.5323 2.99021L2.26684 11.2556C1.17127 12.3512 1.17127 14.1274 2.26684 15.223C3.36241 16.3185 5.13865 16.3185 6.23422 15.223L11.8847 9.57244C12.6981 8.75907 12.6981 7.44032 11.8847 6.62698C11.0714 5.81361 9.75262 5.81361 8.93929 6.62698L5.07544 10.4908C4.78905 10.7772 4.31146 10.786 4.03049 10.4943C3.75799 10.2115 3.76123 9.7612 4.04016 9.48227L7.91736 5.60506C9.2951 4.22732 11.5289 4.22732 12.9066 5.60506C14.2844 6.9828 14.2844 9.21659 12.9066 10.5943L7.25614 16.2449C5.59621 17.9048 2.90489 17.9048 1.24495 16.2449Z"
          fill="#CEB2E9"
        />
        <path
          d="M7.46806 16.0331L12.9082 10.593C14.2859 9.21522 14.2859 6.98143 12.9082 5.60369C12.827 5.52255 12.7427 5.44661 12.656 5.375C13.7998 6.76089 13.7239 8.81546 12.4273 10.1121L6.77679 15.7626C5.19778 17.3416 2.68565 17.4184 1.01562 15.9935C1.08868 16.0791 1.16553 16.1625 1.2465 16.2435C2.90643 17.9034 5.59772 17.9034 7.25769 16.2435L7.46806 16.0331Z"
          fill="#6C3F99"
        />
        <path
          d="M8.45887 6.14519L4.59505 10.009C4.39818 10.2059 4.11095 10.2716 3.85938 10.1987C3.89126 10.306 3.94821 10.4075 4.03101 10.4935C4.31198 10.7851 4.78957 10.7763 5.07596 10.4899L8.93977 6.62609C9.67123 5.89463 10.8112 5.82136 11.6249 6.40548C11.5595 6.31436 11.4863 6.2271 11.4043 6.14519C10.591 5.33181 9.27224 5.33181 8.45887 6.14519Z"
          fill="#6C3F99"
        />
        <path
          d="M16.5433 1.96648C16.4624 1.88562 16.3793 1.80848 16.2945 1.73438C18.0009 3.68794 17.9237 6.65737 16.0624 8.51865L8.02084 16.5603C7.82396 16.7571 7.53673 16.8228 7.28516 16.75C7.31704 16.8573 7.374 16.9588 7.45679 17.0447C7.73776 17.3364 8.21536 17.3275 8.50174 17.0412L16.5433 8.99959C18.4854 7.05742 18.4854 3.90861 16.5433 1.96648Z"
          fill="#6C3F99"
        />
      </g>
      <defs>
        <clipPath id="clip0_1603_169619">
          <rect
            width="18"
            height="18"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
